import { Component, Input, NgModule } from '@angular/core';
import { config, BarcodeService, BarcodeQuery, BalanceQuery, MemberCardQuery, MemberQuery, SeatingDetailQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CashBackToggleModule } from '@fgb/portal-component-library/src/lib/ecash/cash-back-toggle';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { QRCodeModule } from 'angularx-qrcode';
import { MobilePassModule } from '@fgb/portal-component-library/src/lib/passes/mobile-pass';
import { MobilePassModalModule } from '@fgb/portal-component-library/src/lib/passes/mobile-pass-modal';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'angularx-qrcode';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@fgb/portal-component-library/src/lib/passes/mobile-pass';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/ecash/cash-back-toggle';
import * as ɵngcc7 from '@ngx-translate/core';
import * as ɵngcc8 from '@fgb/portal-component-library/src/lib/pipes';

function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_h5_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h5", 27);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const memberDetails_r15 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", memberDetails_r15.FirstName, " ", memberDetails_r15.Surname, " ");
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "img", 28);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵtemplate(2, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_h5_2_Template, 2, 2, "h5", 23);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementStart(4, "div", 24);
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "div", 25);
    ɵngcc0.ɵɵelementStart(8, "div", 26);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_ng_container_10_Template, 2, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const card_r12 = ctx.ngIf;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 4, ctx_r6.memberDetails$));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(card_r12.ProductCode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(card_r12.MemberId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.barcodeOptions == null ? null : ctx_r6.barcodeOptions.showLogo);
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 31);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "member.card.points.balance"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, ctx_r7.pointsBalance$));
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "label", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 31);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "FortressCurrencyPipe");
    ɵngcc0.ɵɵpipe(7, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "member.card.ecash.balance"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, ɵngcc0.ɵɵpipeBind1(7, 6, ctx_r8.ecash$)));
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "hr", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 33);
    ɵngcc0.ɵɵelementStart(3, "div", 34);
    ɵngcc0.ɵɵelementStart(4, "label", 35);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 36);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 37);
    ɵngcc0.ɵɵelementStart(10, "label", 35);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 36);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 38);
    ɵngcc0.ɵɵelementStart(16, "label", 35);
    ɵngcc0.ɵɵtext(17);
    ɵngcc0.ɵɵpipe(18, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 36);
    ɵngcc0.ɵɵtext(20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const card_r3 = ɵngcc0.ɵɵnextContext(2).ngIf;
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 12, "member.card.seat.label"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("justify-content-center", !card_r3.Seat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", (card_r3 == null ? null : card_r3.Seat) || "--", " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 14, "member.card.row.label"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("justify-content-center", !card_r3.Row);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", (card_r3 == null ? null : card_r3.Row) || "--", " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(18, 16, "member.card.block.label"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("justify-content-center", !card_r3.Area);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", (card_r3 == null ? null : card_r3.Area) || "--", " ");
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵelement(1, "fgbcl-cash-back-toggle");
    ɵngcc0.ɵɵelementEnd();
} }
function BarcodeComponent_div_0_ng_container_2_ng_container_3_hr_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hr", 40);
} }
const _c0 = function () { return ["/payment"]; };
function BarcodeComponent_div_0_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_3_Template, 11, 6, "div", 8);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelement(5, "hr", 9);
    ɵngcc0.ɵɵelementStart(6, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "div", 11);
    ɵngcc0.ɵɵtemplate(8, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_8_Template, 7, 6, "div", 12);
    ɵngcc0.ɵɵtemplate(9, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_9_Template, 8, 8, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 14);
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelementStart(12, "button", 16);
    ɵngcc0.ɵɵelement(13, "span", 17);
    ɵngcc0.ɵɵelementStart(14, "span", 18);
    ɵngcc0.ɵɵtext(15, "Add Payment Card");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, BarcodeComponent_div_0_ng_container_2_ng_container_3_ng_container_16_Template, 21, 18, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, BarcodeComponent_div_0_ng_container_2_ng_container_3_div_17_Template, 2, 0, "div", 19);
    ɵngcc0.ɵɵtemplate(18, BarcodeComponent_div_0_ng_container_2_ng_container_3_hr_18_Template, 1, 0, "hr", 20);
    ɵngcc0.ɵɵelement(19, "fgbcl-mobile-pass", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 8, ctx_r4.card$));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.pointsBalance$);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.ecash$);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(10, _c0));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.barcodeOptions == null ? null : ctx_r4.barcodeOptions.showSeating);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.showCashBackToggle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.showCashBackToggle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("separateTop", true);
} }
function BarcodeComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "qrcode", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BarcodeComponent_div_0_ng_container_2_ng_container_3_Template, 20, 11, "ng-container", 3);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const barcode_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("qrdata", barcode_r1.Barcode)("size", 256)("level", "M")("usesvg", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 5, ctx_r2.member$));
} }
function BarcodeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BarcodeComponent_div_0_ng_container_2_Template, 5, 7, "ng-container", 3);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r0.card$));
} }
class BarcodeComponent {
    constructor(barcodeService, barcodeQuery, balanceQuery, memberCardQuery, memberDetailsQuery, seatingDetailQuery, memberQuery) {
        this.barcodeService = barcodeService;
        this.barcodeQuery = barcodeQuery;
        this.balanceQuery = balanceQuery;
        this.memberCardQuery = memberCardQuery;
        this.memberDetailsQuery = memberDetailsQuery;
        this.seatingDetailQuery = seatingDetailQuery;
        this.memberQuery = memberQuery;
        this.primaryTheme = false;
        this.showCashBackToggle = false;
        this.barcodeOptions = { showSeating: false, showLogo: true };
        this.config = config;
    }
    set options(value) {
        this.barcodeOptions = Object.assign(Object.assign({}, this.barcodeOptions), value);
    }
    ngOnInit() {
        this.seatingDetail$ = this.seatingDetailQuery.selectCurrentSeatingDetails();
        this.barcodeService.fetchBarcode().toPromise();
        this.barcode$ = this.barcodeQuery.select();
        this.member$ = this.memberDetailsQuery.selectMemberDetails();
        this.card$ = this.memberCardQuery.selectCurrentCard();
        this.memberDetails$ = this.memberQuery.selectMemberDetails();
        this.pointsBalance$ = this.balanceQuery.selectPurse(this.config.purseConfig.virtualLoyalty);
        this.ecash$ = this.balanceQuery.selectPurse(this.config.purseConfig.combined);
    }
}
BarcodeComponent.ɵfac = function BarcodeComponent_Factory(t) { return new (t || BarcodeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BarcodeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BarcodeQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.BalanceQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberCardQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SeatingDetailQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MemberQuery)); };
BarcodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BarcodeComponent, selectors: [["fgbcl-barcode"]], inputs: { primaryTheme: "primaryTheme", showCashBackToggle: "showCashBackToggle", options: "options", memberId: "memberId" }, decls: 2, vars: 3, consts: [["class", "barcode", 4, "ngIf"], [1, "barcode"], [1, "p-0", "mb-4", "d-flex", "flex-wrap", "flex-column", "justify-content-around", "align-items-center", "rounded", "shadow"], [4, "ngIf"], [1, "qr", "mx-3", "mt-3", "mb-2"], [3, "qrdata", "size", "level", "usesvg"], [1, "w-100", "barcode-content-container", "pt-3"], [1, "barcode-content", "mx-3", "pb-2"], ["class", "d-flex justify-content-between align-items-center", 4, "ngIf"], [1, "separator"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "d-flex", "align-items-end", "mb-1"], ["class", "card-account-no text-left border-right pr-3", 4, "ngIf"], ["class", "card-id ecash-balance text-left pl-3 border-right pr-3", 4, "ngIf"], [1, "d-block", "d-lg-none"], [1, "d-lg-none", "d-block"], ["type", "button", 1, "btn", "wallet-button", "border-0", "p-0", "d-flex", "justify-content-center", "align-items-center", 3, "routerLink"], [1, "icon", "icon-settings-1", "ml-2"], [1, "ml-1", "wallet-button-text"], ["class", "cash-back-toggle-container px-3 py-2", 4, "ngIf"], ["class", "mobile-pass-container mx-3 my-0", 4, "ngIf"], [1, "text-white", 3, "separateTop"], [1, "card-id", "text-left"], ["class", "mb-1 card-name w-80", 4, "ngIf"], [1, "d-flex", "product-code"], [1, "px-2", "divider"], [1, "card-member-id"], [1, "mb-1", "card-name", "w-80"], ["alt", "", "src", "assets/images/logo.svg", "draggable", "false", 1, "card-logo"], [1, "card-account-no", "text-left", "border-right", "pr-3"], [1, "mb-1"], [1, "value"], [1, "card-id", "ecash-balance", "text-left", "pl-3", "border-right", "pr-3"], [1, "d-flex", "card-info", "mb-2"], [1, "text-white", "card-seat"], [1, "font-size-12"], [1, "font-size-14", "d-flex"], [1, "text-white", "card-row"], [1, "text-white", "card-area"], [1, "cash-back-toggle-container", "px-3", "py-2"], [1, "mobile-pass-container", "mx-3", "my-0"]], template: function BarcodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BarcodeComponent_div_0_Template, 4, 3, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.barcode$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.QRCodeComponent, ɵngcc4.RouterLink, ɵngcc5.MobilePassComponent, ɵngcc6.CashBackToggleComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc7.TranslatePipe, ɵngcc8.FortressCurrencyPipe], styles: [".qr[_ngcontent-%COMP%]{flex:0 0 auto}@media screen and (min-width:425px){.qr[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px}}.barcode-content-container[_ngcontent-%COMP%]{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.barcode-content-container[_ngcontent-%COMP%]   .barcode-content[_ngcontent-%COMP%]{line-height:16px}.card-account-no[_ngcontent-%COMP%], .card-id[_ngcontent-%COMP%]{line-height:1rem}.card-account-no[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .card-id[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{font-size:.75rem}.card-id[_ngcontent-%COMP%]{margin-top:-6px}.card-member-id[_ngcontent-%COMP%]:before{content:\"\"}.divider[_ngcontent-%COMP%]:after{content:\"|\"}.card-info[_ngcontent-%COMP%]{width:100%;align-items:center}.card-info[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:0}.card-info[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:not(:first-child){margin-left:15px}hr[_ngcontent-%COMP%]{margin:12px .05rem}.card-logo[_ngcontent-%COMP%]{height:36px}.apple-google-logos[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:45px}"] });
BarcodeComponent.ctorParameters = () => [
    { type: BarcodeService },
    { type: BarcodeQuery },
    { type: BalanceQuery },
    { type: MemberCardQuery },
    { type: MemberQuery },
    { type: SeatingDetailQuery },
    { type: MemberQuery }
];
BarcodeComponent.propDecorators = {
    memberId: [{ type: Input }],
    primaryTheme: [{ type: Input }],
    showCashBackToggle: [{ type: Input }],
    options: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarcodeComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-barcode',
                template: "<div class=\"barcode\" *ngIf=\"barcode$ | async as barcode\">\r\n  <div class=\"p-0 mb-4 d-flex flex-wrap flex-column justify-content-around align-items-center rounded shadow\">\r\n    <ng-container *ngIf=\"card$ | async as card\">\r\n      <div class=\"qr mx-3 mt-3 mb-2\">\r\n        <qrcode [qrdata]=\"barcode.Barcode\" [size]=\"256\" [level]=\"'M'\" [usesvg]=\"true\"></qrcode>\r\n      </div>\r\n      <ng-container *ngIf=\"member$ | async as member\">\r\n        <!-- Not Owner Barcode Body -->\r\n        <div class=\"w-100 barcode-content-container pt-3\">\r\n          <div class=\"barcode-content mx-3 pb-2\">\r\n            <div class=\"d-flex justify-content-between align-items-center\" *ngIf=\"card$ | async as card\">\r\n              <!--Name and ID-->\r\n              <div class=\"card-id text-left\">\r\n                <h5 class=\"mb-1 card-name w-80\" *ngIf=\"memberDetails$ | async as memberDetails\">\r\n                  {{ memberDetails.FirstName }} {{ memberDetails.Surname }}\r\n                </h5>\r\n                <div class=\"d-flex product-code\">\r\n                  <div>{{ card.ProductCode }}</div>\r\n                  <div class=\"px-2 divider\"></div>\r\n                  <div class=\"card-member-id\">{{ card.MemberId }}</div>\r\n                </div>\r\n              </div>\r\n              <!--Logo-->\r\n              <ng-container *ngIf=\"barcodeOptions?.showLogo\">\r\n                <img alt=\"\" class=\"card-logo\" src=\"assets/images/logo.svg\" draggable=\"false\" />\r\n              </ng-container>\r\n            </div>\r\n            <hr class=\"separator\"/>\r\n            <div class=\"d-flex justify-content-between align-items-center\">\r\n              <div class=\"d-flex align-items-end mb-1\">\r\n                <div class=\"card-account-no text-left border-right pr-3\" *ngIf=\"pointsBalance$\">\r\n                  <label class=\"mb-1\">{{ 'member.card.points.balance' | translate }}</label>\r\n                  <div class=\"value\">{{ pointsBalance$ | async }}</div>\r\n                </div>\r\n                <div class=\"card-id ecash-balance text-left pl-3 border-right pr-3\" *ngIf=\"ecash$\">\r\n                  <label class=\"mb-1\">{{ 'member.card.ecash.balance' | translate }}</label>\r\n                  <div class=\"value\">{{ ecash$ | async | FortressCurrencyPipe }}</div>\r\n                </div>\r\n              </div>\r\n              <div class=\"d-block d-lg-none\">\r\n                <div class=\"d-lg-none d-block\">\r\n                  <button\r\n                    type=\"button\"\r\n                    class=\"btn wallet-button border-0 p-0 d-flex justify-content-center align-items-center\"\r\n                    [routerLink]=\"['/payment']\"\r\n                  >\r\n                    <span class=\"icon icon-settings-1 ml-2\"></span>\r\n                    <span class=\"ml-1 wallet-button-text\">Add Payment Card</span>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <ng-container *ngIf=\"barcodeOptions?.showSeating\">\r\n              <hr class=\"separator\"/>\r\n              <div class=\"d-flex card-info mb-2\">\r\n                <div class=\"text-white card-seat\">\r\n                  <label class=\"font-size-12\">{{ 'member.card.seat.label' | translate }}</label>\r\n                  <div class=\"font-size-14 d-flex\" \r\n                      [class.justify-content-center]=\"!card.Seat\">{{ card?.Seat || '--' }}\r\n                  </div>\r\n                </div>\r\n                <div class=\"text-white card-row\">\r\n                  <label class=\"font-size-12\">{{ 'member.card.row.label' | translate }}</label>\r\n                  <div class=\"font-size-14 d-flex\" \r\n                      [class.justify-content-center]=\"!card.Row\">{{ card?.Row || '--' }}\r\n                  </div>\r\n                </div>\r\n                <div class=\"text-white card-area\">\r\n                  <label class=\"font-size-12\">{{ 'member.card.block.label' | translate }}</label>\r\n                  <div class=\"font-size-14 d-flex\" \r\n                      [class.justify-content-center]=\"!card.Area\">{{ card?.Area || '--' }}\r\n                  </div>\r\n                </div> \r\n              </div>\r\n            </ng-container>\r\n  \r\n          </div>\r\n          <div *ngIf=\"showCashBackToggle\" class=\"cash-back-toggle-container px-3 py-2\">\r\n            <fgbcl-cash-back-toggle></fgbcl-cash-back-toggle>\r\n          </div>\r\n          <hr *ngIf=\"!showCashBackToggle\" class=\"mobile-pass-container mx-3 my-0\" />\r\n            <fgbcl-mobile-pass class=\"text-white\" [separateTop]=\"true\"></fgbcl-mobile-pass>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n",
                styles: [".qr{flex:0 0 auto}@media screen and (min-width:425px){.qr{padding-top:10px;padding-bottom:10px}}.barcode-content-container{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.barcode-content-container .barcode-content{line-height:16px}.card-account-no,.card-id{line-height:1rem}.card-account-no div,.card-id div{font-size:.75rem}.card-id{margin-top:-6px}.card-member-id:before{content:\"\"}.divider:after{content:\"|\"}.card-info{width:100%;align-items:center}.card-info label{margin-bottom:0}.card-info>div:not(:first-child){margin-left:15px}hr{margin:12px .05rem}.card-logo{height:36px}.apple-google-logos img{height:45px}"]
            }]
    }], function () { return [{ type: ɵngcc1.BarcodeService }, { type: ɵngcc1.BarcodeQuery }, { type: ɵngcc1.BalanceQuery }, { type: ɵngcc1.MemberCardQuery }, { type: ɵngcc1.MemberQuery }, { type: ɵngcc1.SeatingDetailQuery }, { type: ɵngcc1.MemberQuery }]; }, { primaryTheme: [{
            type: Input
        }], showCashBackToggle: [{
            type: Input
        }], options: [{
            type: Input
        }], memberId: [{
            type: Input
        }] }); })();

class BarcodeModule {
}
BarcodeModule.ɵfac = function BarcodeModule_Factory(t) { return new (t || BarcodeModule)(); };
BarcodeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BarcodeModule });
BarcodeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CashBackToggleModule,
            PipesModule,
            RouterModule,
            QRCodeModule,
            MobilePassModule,
            MobilePassModalModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BarcodeModule, { declarations: function () { return [BarcodeComponent]; }, imports: function () { return [CommonModule,
        CashBackToggleModule,
        PipesModule,
        RouterModule,
        QRCodeModule,
        MobilePassModule,
        MobilePassModalModule, ɵngcc7.TranslateModule]; }, exports: function () { return [BarcodeComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BarcodeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    BarcodeComponent
                ],
                imports: [
                    CommonModule,
                    CashBackToggleModule,
                    PipesModule,
                    RouterModule,
                    QRCodeModule,
                    MobilePassModule,
                    MobilePassModalModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [
                    BarcodeComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BarcodeComponent, BarcodeModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-user-barcode.js.map